module.exports = __webpack_public_path__ + "img/networkSecurity.0d3b2cfd.jpg";